import React from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material';
import logo from '../../../assets/icons/logo.png'
import theme from '../../../theme';

function CustomerReviewComponent() {

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: isMobile ? "10px" : "20px",
      }}
    >
      <Typography
        variant='p'
        sx={{
          fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
          fontWeight: 700,
          fontSize: isMobile ? "14px" : "18px", // Adjust font size for mobile
          textAlign: "center",
        }}
      >
        "Real Stories. Real Style. See what our customers are saying!"
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // Stack boxes on mobile
          marginTop: "40px",
          alignItems: isMobile ? "center" : "flex-start", // Center on mobile
          justifyContent: isMobile ? "center" : "space-evenly",
          gap: isMobile ? "20px" : "0", // Add spacing between boxes on mobile

        }}
      >
        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            Mandalay HW က အိမ်ဆောက်ပစ္စည်း၊ ကုန်ပစ္စည်း၊ စက်ပစ္စည်းတွေကို
            တစ်နေရာတည်းကနေ စုံစုံလင်လင် ရနိုင်လို့ အရမ်းအဆင်ပြေပါတယ်။
            လိုအပ်တဲ့ပစ္စည်းတွေကို မြန်မြန်ဆန်ဆန် ရှာလို့ရပြီး စျေးနှုန်းလည်း
            စိတ်ချရပါတယ်။
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              Mandalay HW
            </p>
          </Box>
        </Box>

        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            လက်လီလက်ကား တန်ဖိုးညီတဲ့ စျေးနှုန်းနဲ့ ပစ္စည်းမှန်တွေကို
            တစ်နေရာတည်းမှာ ရနိုင်တာက အားသာချက်ပါ။ ဆောက်လုပ်ရေးအတွက် လိုတဲ့
            ပစ္စည်းတွေကို တစ်ခါတည်း စီစဉ်ပြီး အချိန်ကုန်သက်သာစေပါတယ်။
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              Mandalay HW
            </p>
          </Box>
        </Box>

        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            ပစ္စည်းစုံစုံလင်လင် ရရှိနိုင်ပြီး ဝန်ဆောင်မှုလည်း
            ယုံကြည်စိတ်ချရပါတယ်။ လိုအပ်တဲ့ပစ္စည်းတွေကို တစ်နေရာတည်းမှာ
            စိတ်ချသက်သာနဲ့ ဝယ်ယူနိုင်တာကြောင့် လုပ်ငန်းအတွက် အလွန်အသုံးဝင်ပါတယ်။

          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              Mandalay HW
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CustomerReviewComponent
